import React, { useState } from 'react';
import { Button } from '@fluentui/react-components';
import { ClockFilled, DismissFilled } from '@fluentui/react-icons';
import { Responder, useDenyResponder, useUpdateResponder } from "#root/queries/responders";
import { RESPONDER_STATUS } from "#root/utils/responders";
import './styles.scss';
import { DialogBox } from "#root/components/DialogBox";
import { showToast } from "#root/components/GlobalToaster";
import RespondersList from '#root/components/RespondersList';

const ResponderCheckIn: React.FC = () => {
  const [denyDialogOpen, setDenyDialogOpen] = useState(false);
  const [selectedResponder, setSelectedResponder] = useState<Responder | null>(null);

  const updateResponder = useUpdateResponder();
  const denyResponder = useDenyResponder();

const handleCheckInPending = async (responder: Responder) => {
  try {
    await updateResponder.mutateAsync({
      responder: {
        id: responder.id,
        status: RESPONDER_STATUS.APPROVED
      }
    });

    showToast("Responder approved successfully", "success");
  } catch (error: any) {
    const errorMessage = error?.response?.data?.Message || error?.message || "Failed to approve responder";
    showToast(errorMessage, "error");
  }
};


  const handleDeny = async (responder: Responder) => {
    setSelectedResponder(responder);
    setDenyDialogOpen(true);
  };

  const handleDenyConfirm = async () => {
    try {
      await denyResponder.mutateAsync({
        id: selectedResponder?.id!,
      });
      showToast("Responder denied successfully", "success");
      setDenyDialogOpen(false);
      setSelectedResponder(null);
    } catch (error) {
      showToast("Failed to deny responder", "error");
    }
  };

  const renderActions = (responder: Responder, onActionComplete?: () => void) => {
    return (
      <>
        <Button
          icon={<ClockFilled />}
          appearance="primary"
          onClick={() => {
            handleCheckInPending(responder);
            if (onActionComplete) onActionComplete();
          }}
          disabled={updateResponder.isPending}
        >
          Check In Pending
        </Button>
        <Button
          icon={<DismissFilled />}
          appearance="outline"
          onClick={() => {
            handleDeny(responder);
            if (onActionComplete) onActionComplete();
          }}
          disabled={denyResponder.isPending}
        >
          Deny
        </Button>
      </>
    );
  };

  return (
    <>
      <RespondersList
        title="Pending Responders"
        status={RESPONDER_STATUS.PENDING}
        className="pending-responders"
        renderActions={renderActions}
        selectEnabled={false}
      />

      {selectedResponder && (
        <DialogBox
          open={denyDialogOpen}
          onOpenChange={open => setDenyDialogOpen(open)}
          title="Deny Request"
          primaryButtonText="Deny"
          onPrimaryButtonClick={handleDenyConfirm}
          isPrimaryButtonLoading={denyResponder.isPending}
          onSecondaryButtonClick={() => setDenyDialogOpen(false)}
        >
          Are you sure you want to deny responder request? You can't undo this.
        </DialogBox>
      )}
    </>
  );
};

export default ResponderCheckIn;
